import { serverNotificationEndpoints } from '../../utils/commonVariables/endpoints';
import api from '../api';

export const getInitialServerNotifications = async () => {
    const url = serverNotificationEndpoints.initialServerNotifications;
    const response = await api.get(url);
    return response.data;
};

export const resolveAlert = async (id: string) => {
    const { data } = await api.post(serverNotificationEndpoints.resolveAlert, {
        IdAlert: parseInt(id),
    });

    return data;
};

export const resolveAllAlerts = async (ids: string[]) => {
    const { data } = await api.post(
        serverNotificationEndpoints.resolveAllAlerts,
        ids
    );
    return data;
};
